import { all, call, takeEvery, fork } from "redux-saga/effects";
import requestFunction from "../Utils/sagasGenericFunction";

import {
  FETCH_ALL_COUNTRIES,
  CREATE_SONG,
  EDIT_SONG,
  DELETE_SONG,
  FETCH_SONGS,
  FETCH_SONG_BY_ID,
  FETCH_ALL_BANNERS,
  FETCH_BANNER_BY_ID,
  CREATE_BANNER,
  UPDATE_BANNER,
  DELETE_BANNER,
  FETCH_ALL_PROMPT,
  FETCH_PROMPT_BY_ID,
  CREATE_PROMPT,
  UPDATE_PROMPT,
  DELETE_PROMPT,
} from "../ActionTypes";

import {
  getCountries,
  addSongPost,
  editSongPost,
  deleteSongGet,
  getSongs,
  getSongById,
  getBanners,
  getBannerById,
  addBannerPost,
  editBannerPost,
  deleteBannerGet,
  getPrompt,
  getPromptById,
  addPromptPost,
  editPromptPost,
  deletePromptGet,
} from "../Api";

import {
  fetchCountriesSuccess,
  fetchSongsSuccess,
  addSongSuccess,
  editSongSuccess,
  deleteSongSuccess,
  fetchSongByIdSuccess,
  fetchAllBannersSuccess,
  fetchBannerByIdSuccess,
  addBannerSuccess,
  editBannerSuccess,
  deleteBannerSuccess,
  fetchAllPromptSuccess,
  fetchPromptByIdSuccess,
  addPromptSuccess,
  editPromptSuccess,
  deletePromptSuccess,
} from "../Actions";

export const fetchCountryRequest = function* ({ payload }) {
  yield call(requestFunction, fetchCountriesSuccess, getCountries, payload);
};

export const fetchAllCounty = function* () {
  yield takeEvery(FETCH_ALL_COUNTRIES, fetchCountryRequest);
};

export const fetchSongRequest = function* ({ payload }) {
  yield call(requestFunction, fetchSongsSuccess, getSongs, payload);
};

export const fetchAllSongss = function* () {
  yield takeEvery(FETCH_SONGS, fetchSongRequest);
};

export const addSongRequest = function* ({ payload }) {
  yield call(requestFunction, addSongSuccess, addSongPost, payload);
};

export const addSongss = function* () {
  yield takeEvery(CREATE_SONG, addSongRequest);
};

export const editSongRequest = function* ({ payload }) {
  yield call(requestFunction, editSongSuccess, editSongPost, payload);
};

export const editSongss = function* () {
  yield takeEvery(EDIT_SONG, editSongRequest);
};

export const deleteSongRequest = function* ({ payload }) {
  yield call(requestFunction, deleteSongSuccess, deleteSongGet, payload);
};

export const deleteSongss = function* () {
  yield takeEvery(DELETE_SONG, deleteSongRequest);
};

export const fetchSongByIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchSongByIdSuccess, getSongById, payload);
};

export const fetchSongByIddx = function* () {
  yield takeEvery(FETCH_SONG_BY_ID, fetchSongByIdRequest);
};

export const fetchBannersRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllBannersSuccess, getBanners, payload);
};

export const fetchAllBan = function* () {
  yield takeEvery(FETCH_ALL_BANNERS, fetchBannersRequest);
};

export const fetchBannersByIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchBannerByIdSuccess, getBannerById, payload);
};

export const fetchBanById = function* () {
  yield takeEvery(FETCH_BANNER_BY_ID, fetchBannersByIdRequest);
};

export const addBannerRequest = function* ({ payload }) {
  yield call(requestFunction, addBannerSuccess, addBannerPost, payload);
};

export const addBann = function* () {
  yield takeEvery(CREATE_BANNER, addBannerRequest);
};

export const editBannerRequest = function* ({ payload }) {
  yield call(requestFunction, editBannerSuccess, editBannerPost, payload);
};

export const editBann = function* () {
  yield takeEvery(UPDATE_BANNER, editBannerRequest);
};

export const deleteBannerRequest = function* ({ payload }) {
  yield call(requestFunction, deleteBannerSuccess, deleteBannerGet, payload);
};

export const deleteBann = function* () {
  yield takeEvery(DELETE_BANNER, deleteBannerRequest);
};

export const fetchPromptRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllPromptSuccess, getPrompt, payload);
};

export const fetchAllPromp = function* () {
  yield takeEvery(FETCH_ALL_PROMPT, fetchPromptRequest);
};

export const fetchPromptByIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchPromptByIdSuccess, getPromptById, payload);
};

export const fetchPromptByIdx = function* () {
  yield takeEvery(FETCH_PROMPT_BY_ID, fetchPromptByIdRequest);
};

export const addPromptRequest = function* ({ payload }) {
  yield call(requestFunction, addPromptSuccess, addPromptPost, payload);
};

export const addPromp = function* () {
  yield takeEvery(CREATE_PROMPT, addPromptRequest);
};

export const editPromptRequest = function* ({ payload }) {
  yield call(requestFunction, editPromptSuccess, editPromptPost, payload);
};

export const editPromp = function* () {
  yield takeEvery(UPDATE_PROMPT, editPromptRequest);
};

export const deletePromptRequest = function* ({ payload }) {
  yield call(requestFunction, deletePromptSuccess, deletePromptGet, payload);
};

export const deletePromp = function* () {
  yield takeEvery(DELETE_PROMPT, deletePromptRequest);
};

export default function* rootSaga() {
  yield all([
    fork(fetchAllCounty),
    fork(fetchAllSongss),
    fork(addSongss),
    fork(editSongss),
    fork(deleteSongss),
    fork(fetchSongByIddx),
    fork(fetchAllBan),
    fork(fetchBanById),
    fork(addBann),
    fork(editBann),
    fork(deleteBann),
    fork(fetchAllPromp),
    fork(fetchPromptByIdx),
    fork(addPromp),
    fork(editPromp),
    fork(deletePromp),
  ]);
}
